// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu-module--menuContainer--1PMlD","menuItem":"menu-module--menuItem--1Rtei"};